import React, { useContext, useRef,useState ,useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { faCheck, faEdit ,faPaperclip, faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import { useFetchQuery } from 'quanta-flows';
import {
  QuantaFormik,
  QuantaForm,
  useQuantaFormikContext,
  useResponsiveParams,
  MixedGridGroup,
  QuantaRadioGroup,
  QuantaInput,
  Text,
  GridItem,
  Paper,
  Grid,
  Button,
  InputGridGroup ,
} from 'quanta-ui';
// import { QuantaConfigContext } from '../../../../../lib/config/ConfigProvider';
import { QuantaConfigContext } from 'quanta-flows';
// import useMutationQuery from '../../../../../lib/graphql/useMutationQuery';
import { useMutationQuery } from 'quanta-flows';
// import Parse from '../../../../../lib/intl/CurrencyFormater';
import { CurrencyFormater } from 'quanta-flows';
// import { Error, Loading } from '../../../../../lib/layout';
import { Error,Loading } from 'quanta-flows/modules/layout';
import { useLazyQuery} from '@apollo/client';
import {
  CUSTOMER_INDIVIDUAL_DROPDOWN_DETAIL,
  CUSTOMER_ORGANISATIONAL_DROPDOWN_DETAIL,
  FINANCER_DROPDOWN_DETAILS,
  GET_BUY_MOTOR_POLICY_VAR_DETAILS,
  GET_CUSTOMER_TYPE_DOMAIN,
  GET_DATE_TIME,
  PREVIOUS_INSURER_COMPANY_LIST,
  //NOMINEE_DROPDOWN_DETAILS,
  PROPOSAL_PAYMENT_TYPE_LIST,
  SAVE_PROPOSAL_MISCD,
  GET_DOCUMENTS_INFO,
  VIEW_DOCUMENT,
  DOCUMENT_STATIC_DATA,
  PROFILE_DETAILS
} from '../queries';
// import { updateBuyMotorPolicy } from '../_graphql/state';
import { updateBuyMotorPolicy } from 'quanta-flows/modules/proposal/motor/state';
// import ProposerCustomerReadOnly from '../../../../common/proposer-customer/proposer-customer-readonly';
import { ProposerCustomerReadOnly } from 'quanta-flows/modules/common/proposer/edit';

export default function ReviewAndConfirmDetails({
  goToStep,
  proceedToNextStep,
  setProceedToNextStep,
  currentStepFunctions,
  setCurrentStepFunctions,
  setParentAlerts,
  setLoadingStep,
  setCustomLoadingMessage,
  productCode,
  lobCode,
  lobName,
  productName,
  productType,
  renderExpandedCards,
  ...props
}) {
  const initLoadRef = useRef([]);
  const mutateQuery = useMutationQuery();
  const { branding } = useContext(QuantaConfigContext);
  const [loadingFetchDocData, setLoadingFetchDocData] =useState(false);
  const [ customerDocumentsPreloadedAuto,setCustomerDocumentsPreloadedAuto,] = useState(null);
  const [customerDocumentListAuto, setCustomerDocumentListAuto] =useState(null);
  const [ErrorFetchDocData, setErrorFetchDocData] = useState(null);
  const [viewDocIdx, setViewDocIdx] = useState(-1);
  const uploadDocRef = useRef([]);
  const {
    loading: loadingPaymentType,
    error: errorPaymentType,
    data: dataPaymentType,
  } = useQuery(PROPOSAL_PAYMENT_TYPE_LIST, {
    fetchPolicy: 'cache-first',
    onCompleted: (_) => {
      initLoadRef.current = [...initLoadRef.current, 1];
    },
  });
  const {
    loading: loadingBuyMotorPolicy,
    error: errorBuyMotorPolicy,
    data: dataBuyMotorPolicy,
    previousData,
  } = useQuery(GET_BUY_MOTOR_POLICY_VAR_DETAILS, {
    fetchPolicy: 'cache-first',
    onCompleted: (_) => {
      initLoadRef.current = [...initLoadRef.current, 2];
    },
  });
  const {
    loading: loadingDateTime,
    error: errorDateTime,
    data: dataDateTime,
    previousData: previousDateTime,
  } = useQuery(GET_DATE_TIME, {
    fetchPolicy: 'network-only',
    skip:
      dataBuyMotorPolicy &&
      dataBuyMotorPolicy?.buyMotorPolicy?.proposalNumber
        ? true
        : false,
    onCompleted: (_) => {
      initLoadRef.current = [...initLoadRef.current, 3];
    },
  });
  const {
    loading: loadingProfile,
    error: loadingError,
    data: dataProfileData,
  } = useQuery(PROFILE_DETAILS, {
    fetchPolicy: 'network-only',

  });
  const {
    loading: loadingUploadedDoc,
    error: errorUploadedDoc,
    data: UploadedDoc,
  } = useQuery(GET_DOCUMENTS_INFO, {
    fetchPolicy: 'cache-and-network',
    variables: {
      input: {
        proposalNumber: dataBuyMotorPolicy?.buyMotorPolicy?.quoteData?.quotationNo
                        ? dataBuyMotorPolicy?.buyMotorPolicy?.quoteData?.quotationNo :'',
      },
    },
    skip:
      dataBuyMotorPolicy &&
      dataBuyMotorPolicy?.buyMotorPolicy?.proposalNumber
        ? true
        : false,
    onCompleted: (data) => {
      setCustomerDocumentsPreloadedAuto(
        data?.getDocumentsForCustomer,
      );
      const { documentDetails , ...restAdditionalTabDetails } = dataBuyMotorPolicy?.buyMotorPolicy?.additionalTabDetails ; 
      updateBuyMotorPolicy({
        additionalTabDetails:{
          ...restAdditionalTabDetails,
          documentDetails :data?.getDocumentsForCustomer, 
        }
      })
      setCustomerDocumentListAuto(data?.documentList);
      setLoadingFetchDocData(false);
    },
    onError : (error) =>{
      setErrorFetchDocData(error);
      setLoadingFetchDocData(false);
    },
  });
  const {
    loading: loadingDocumentExtensions,
    error: errorDocumentExtensions,
    data: dataDocumentExtensions,
  } = useQuery(DOCUMENT_STATIC_DATA, {
    fetchPolicy: 'cache-first',
  });
  // const {
  //  //documentListPCV,
  //   documentExtensions,
  //  // docFileSizeLimit,
  //  // docDescCharacterLimit,
  // } = dataDocumentExtensions;
  // const {
  //   loading: loadingNomineeDropdownDetails,
  //   error: errorNomineeDropdownDetails,
  //   data: dataNomineeDropdownDetails,
  // } = useQuery(NOMINEE_DROPDOWN_DETAILS, {
  //   fetchPolicy: 'cache-first',
  //   variables: {
  //     productCode: product_code || productCode,
  //   },
  //   onCompleted: (_) => {
  //     initLoadRef.current = [...initLoadRef.current, 4];
  //   },
  // });

  const {
    loading: loadingFinancerDropDownDetails,
    error: errorFinancerDropdownDetails,
    data: dataFinancerDropdownDetails,
  } = useQuery(FINANCER_DROPDOWN_DETAILS, {
    fetchPolicy: 'cache-first',
    variables: {
      productCode:3137,
    },
    onCompleted: (_) => {
      initLoadRef.current = [...initLoadRef.current, 5];
    },
  });

  const {
    loading: loadingCustomerType,
    error: errorCustomerType,
    data: dataCustomerType,
  } = useQuery(GET_CUSTOMER_TYPE_DOMAIN, {
    fetchPolicy: 'cache-first',
    onCompleted: (_) => {
      initLoadRef.current = [...initLoadRef.current, 6];
    },
  });

  const {
    loading: loadingIndividualDropDownDetails,
    error: errorIndividualDropDownDetails,
    data: dataIndividualDropDownDetails,
  } = useQuery(CUSTOMER_INDIVIDUAL_DROPDOWN_DETAIL, {
    fetchPolicy: 'cache-first',
    onCompleted: (_) => {
      initLoadRef.current = [...initLoadRef.current, 7];
    },
  });

  const {
    loading: loadingOrganisationDropDownDetails,
    error: errorOrganisationDropDownDetails,
    data: dataOrganisationDropDownDetails,
  } = useQuery(CUSTOMER_ORGANISATIONAL_DROPDOWN_DETAIL, {
    fetchPolicy: 'cache-first',
    onCompleted: (_) => {
      initLoadRef.current = [...initLoadRef.current, 8];
    },
  });

  const {
    loading: loadingPreviousInsurerDetails,
    error: errorPreviousInsurerDetails,
    data: dataPreviousInsurerDetails,
  } = useQuery(PREVIOUS_INSURER_COMPANY_LIST, {
    fetchPolicy: 'cache-first',
    variables: {
      productCode,
    },
    onCompleted: (_) => {
      initLoadRef.current = [...initLoadRef.current, 9];
    },
  });
  const [viewDocument, { loading: loadingDocument }] = useLazyQuery(
    VIEW_DOCUMENT,
    {
      fetchPolicy: 'network-only',
      onError: (error) => {
        setAlerts([
          {
            id: Date.now() + Math.random(),
            header: 'Error fetching document',
            content: <Text>{error?.message}</Text>,
            type: 'error',
            timeout: null,
            disableClose: false,
          },
        ]);
        uploadDocRef.current = [];
      },
      onCompleted: (data) => {
        const { viewDocument } = data;
        const {
          base64String,
          documentExtension,
          documentFileName,
        } = viewDocument;
        /**Solution 1 (downloads doc* files and views other file types) */
        // let byteCharacters = window.atob(
        //   base64String
        //     ?.toString()
        //     ?.split(';')
        //     ?.pop()
        //     ?.split(',')
        //     ?.pop(),
        // );
        // let byteNumbers = new Array(byteCharacters.length);
        // for (let i = 0; i < byteCharacters.length; i++) {
        //   byteNumbers[i] = byteCharacters.charCodeAt(i);
        // }
        // let byteArray = new Uint8Array(byteNumbers);
        // let file = new Blob([byteArray], {
        //   type: `${base64String
        //     ?.toString()
        //     ?.split(';')[0]
        //     ?.split(':')
        //     ?.pop()};base64`,
        // });
        // let fileURL = URL.createObjectURL(file);
        // if (
        //   documentExtensions
        //     ?.find(
        //       (extension) =>
        //         extension?.code?.toString()?.toLowerCase() ===
        //         documentExtension?.toString()?.toLowerCase(),
        //     )
        //     ?.value?.toString()
        //     ?.startsWith('doc')
        // ) {
        //   const downloadLink = document.createElement('a');
        //   const fileName = `${documentFileName}.${
        //     documentExtensions?.find(
        //       (extension) =>
        //         extension?.code?.toString()?.toLowerCase() ===
        //         documentExtension?.toString()?.toLowerCase(),
        //     )?.value
        //   }`;
        //   downloadLink.href = base64String;
        //   downloadLink.download = fileName;
        //   downloadLink.click();
        // } else {
        //   window.open(fileURL);
        // }
        /**Solution 2 (downloads all file types) */
        const downloadLink = document.createElement('a');
        const fileName = `${documentFileName}.${
          documentExtensions?.find(
            (extension) =>
              extension?.code?.toString()?.toLowerCase() ===
              documentExtension?.toString()?.toLowerCase(),
          )?.value
        }`;
        downloadLink.href = base64String;
        downloadLink.download = fileName;
        downloadLink.click();
      },
    },
  );
  if (
    loadingPaymentType ||
    loadingBuyMotorPolicy ||
    loadingDateTime ||
    // loadingNomineeDropdownDetails ||
    loadingFinancerDropDownDetails ||
    loadingCustomerType ||
    loadingIndividualDropDownDetails ||
    loadingOrganisationDropDownDetails ||
    loadingPreviousInsurerDetails ||
    loadingFetchDocData||
    loadingDocument ||
    loadingDocumentExtensions||
    loadingProfile
  ) {
    return (
      <div className="min-h-screen">
        <Loading />
      </div>
    );
  }
  if (
    errorPaymentType ||
    errorBuyMotorPolicy ||
    errorDateTime ||
    // errorNomineeDropdownDetails ||
    errorFinancerDropdownDetails ||
    errorCustomerType ||
    errorIndividualDropDownDetails ||
    errorOrganisationDropDownDetails ||
    errorPreviousInsurerDetails ||
    errorDocumentExtensions
  ) {
    return (
      <div className="min-h-screen">
        <Error
          error={
            errorPaymentType ||
            errorBuyMotorPolicy ||
            errorDateTime ||
            // errorNomineeDropdownDetails ||
            errorFinancerDropdownDetails ||
            errorCustomerType ||
            errorIndividualDropDownDetails ||
            errorOrganisationDropDownDetails ||
            errorPreviousInsurerDetails
          }
        />
      </div>
    );
  }
  const { buyMotorPolicy } = dataBuyMotorPolicy;
  const { ProposalPaymentTypeList } = dataPaymentType;
  const {
    //documentListPCV,
     documentExtensions,
    // docFileSizeLimit,
    // docDescCharacterLimit,
   } = dataDocumentExtensions;
  const { datetimeValue } = dataDateTime
    ? dataDateTime
    : previousDateTime
    ? previousDateTime
    : { time: null, date: buyMotorPolicy?.policy?.date };
  // const { PRD_NomiRelationWithMemb, PRD_ApointRelationWithMinNomi } =
  //   dataNomineeDropdownDetails;
  const { PRD_FinancerAgreementType, PRD_IsYourVehicle } =
    dataFinancerDropdownDetails;
  const { customerTypeList } = dataCustomerType;
  const {
    idProofTypeList,
    maritalStatusList,
    nationalityList,
    genderList,
    salutationList,
  } = dataIndividualDropDownDetails;
  const { organisationList } = dataOrganisationDropDownDetails;
  const { rolloverCompanyList } = dataPreviousInsurerDetails;
  const documentsPreloaded =
      customerDocumentsPreloadedAuto &&
      customerDocumentsPreloadedAuto?.length > 0
        ? customerDocumentsPreloadedAuto
        : null ;//data?.getDocumentsForCustomer;
    const documentList =
      customerDocumentListAuto && customerDocumentListAuto?.length > 0
        ? customerDocumentListAuto
        : null ;// data?.documentList;
        const obj = { dataProfileData };
        const value = Object.values(obj);
       
        const mapUserId = value?.[0]?.userMyDetail?.userId;
  const validate = (values) => {
    return {};
  };
  const getDomainData = (
    domainArr,
    searchText,
    searchType,
    returnType,
  ) => {
    return domainArr.find(
      (d) =>
        d[`${searchType}`]?.toLowerCase() ===
        searchText?.toLowerCase(),
    )
      ? domainArr.find(
          (d) =>
            d[`${searchType}`]?.toLowerCase() ===
            searchText?.toLowerCase(),
        )[`${returnType}`]
      : '';
  };

  const initialValues = {
    isProposalCreated:
      buyMotorPolicy?.proposalNumber?.length > 0 ? true : false,
    leadGenerator: buyMotorPolicy?.reviewAndConfirmTabDetails
      ?.leadGenerator
      ? `${buyMotorPolicy?.reviewAndConfirmTabDetails?.leadGenerator}`
      : '',
    proposalPaymentType: buyMotorPolicy?.reviewAndConfirmTabDetails
      ?.proposalPaymentType
      ? `${buyMotorPolicy?.reviewAndConfirmTabDetails?.proposalPaymentType}`
      : ProposalPaymentTypeList && ProposalPaymentTypeList?.length > 0
      ? ProposalPaymentTypeList[0]?.code
      : '',
      ownerDriverSelect:buyMotorPolicy?.coverData?.addOnCovers[`Owner Driver`]?.selected
      ?true
      :false
  };

  const getSaveProposalMutationVariables = (values) => {
    let riskInput = [];
    buyMotorPolicy?.coverData?.rawRiskData?.forEach((r) => {
      let covers = [];
      r.covers
        .filter(
          (c) =>
            buyMotorPolicy?.coverData?.addOnCovers[c?.name]?.selected,
        )
        .forEach((c) => {
          const { selected, attributes, ...rest } = c;
          let attributesArr = [];
          c?.attributes?.forEach((attribute) => {
            attributesArr.push({
              ...attribute,
              value: attribute?.showOnScreen
                ? `${
                    buyMotorPolicy?.coverData?.addOnCovers[
                      `${c?.name}`
                    ][`attributes`][`${attribute?.name}`]
                  }`
                : `${attribute?.defaultValue}`,
            });
          });
          covers.push({
            ...rest,
            attributes: [...attributesArr],
          });
        });
      if (covers?.length !== 0) {
        riskInput.push({
          riskType: r?.riskType,
          covers,
        });
      }
    });
    let ownerDriverSelected='false';
    if (buyMotorPolicy?.coverData?.addOnCovers[`Owner Driver`]?.selected)
             {
              ownerDriverSelected= 'true'
             }
    let  trailerArr = [];
  buyMotorPolicy?.quoteData?.trailerDetails?.forEach((_, idx) => {
   trailerArr.push({
       make: buyMotorPolicy?.quoteData?.trailerDetails[idx].make,
       model: buyMotorPolicy?.quoteData?.trailerDetails[idx].model,
       regnumber: buyMotorPolicy?.quoteData?.trailerDetails[idx].regnumber,
       ChassisNumber:buyMotorPolicy?.quoteData?.trailerDetails[idx].ChassisNumber,
       SI: buyMotorPolicy?.quoteData?.trailerDetails[idx].SI,
       yearofmanufacture: buyMotorPolicy?.quoteData?.trailerDetails[idx].yearofmanufacture,
     });
   });
    return {
      input: {
        productCode
        :buyMotorPolicy?.quoteData?.productVariant?.toLowerCase()?.search('comprehensive') !== -1
        ?'3128'
        :buyMotorPolicy?.quoteData?.productVariant?.toLowerCase()?.search('liability') !== -1
        ?'3129'
        :'3128',
        UserId:mapUserId?mapUserId:'',
        productType: buyMotorPolicy?.quoteData?.productType
          ? `${buyMotorPolicy?.quoteData?.productType}`
          : '',
        customerType: buyMotorPolicy?.proposerDetails?.customerType
          ? `${buyMotorPolicy?.proposerDetails?.customerType}`
          : '',
        gender: buyMotorPolicy?.proposerDetails?.gender
          ? `${buyMotorPolicy?.proposerDetails?.gender}`
          : '',
        businessType: buyMotorPolicy?.quoteData?.businessType
          ? `${buyMotorPolicy?.quoteData?.businessType}`
          : '',
        intermediary: {
          intermediaryCode: buyMotorPolicy?.intermediaryDetails?.code,
          locationCode: buyMotorPolicy?.intermediaryDetails?.location,
          fieldUserCode:
            buyMotorPolicy?.intermediaryDetails?.fieldUserCode,
        },
        isTrailerRequired:buyMotorPolicy?.quoteData?.isTrailerRequired
        ?buyMotorPolicy?.quoteData?.isTrailerRequired
        :false,
        nooftrailers:buyMotorPolicy?.quoteData?.nooftrailers
        ?buyMotorPolicy?.quoteData?.nooftrailers
        :'',
        coverforlamps:buyMotorPolicy?.quoteData?.coverforlamps
        ?buyMotorPolicy?.quoteData?.coverforlamps
        :false,
        coverforprivateandcommercial:buyMotorPolicy?.quoteData?.coverforprivateandcommercial
        ?buyMotorPolicy?.quoteData?.coverforprivateandcommercial
        :false,
        vehicleusedlimitedtoownpremises:buyMotorPolicy?.quoteData?.vehicleusedlimitedtoownpremises
        ?buyMotorPolicy?.quoteData?.vehicleusedlimitedtoownpremises
        :false,
        vehicleuseddrivingtuitions:buyMotorPolicy?.quoteData?.vehicleuseddrivingtuitions
        ?buyMotorPolicy?.quoteData?.vehicleuseddrivingtuitions
        :false,
        ImportedVehicle:buyMotorPolicy?.quoteData?.ImportedVehicle
        ?buyMotorPolicy?.quoteData?.ImportedVehicle
        :false,
        ConfinedtoOwnPremises:buyMotorPolicy?.quoteData?.ConfinedtoOwnPremises
        ?buyMotorPolicy?.quoteData?.ConfinedtoOwnPremises
        :false,
        SoftCopyDiscount:buyMotorPolicy?.quoteData?.SoftCopyDiscount
        ?buyMotorPolicy?.quoteData?.SoftCopyDiscount
        :false,
        AntiTheftDiscount:buyMotorPolicy?.quoteData?.AntiTheftDiscount
        ?buyMotorPolicy?.quoteData?.AntiTheftDiscount
        :false,
        towedby:buyMotorPolicy?.quoteData?.towedby
        ?buyMotorPolicy?.quoteData?.towedby
        :'',
        totalIDV:buyMotorPolicy?.quoteData?.totalIDV,
        bodyIDV:buyMotorPolicy?.quoteData?.bodyIDV,
        tenure:
          buyMotorPolicy?.quoteData?.tenure ||
          buyMotorPolicy?.quoteData?.premiumData?.tenure
            ? `${
                buyMotorPolicy?.quoteData?.tenure ||
                buyMotorPolicy?.quoteData?.premiumData?.tenure
              }`
            : '',
        rto: {
          rtoAuthCode: buyMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.rtoDetails?.rtoAuthorityCode
            ? `${buyMotorPolicy?.vehicleTabDetails?.vehicleDetails?.rtoDetails?.rtoAuthorityCode}`
            : '',
          rtoLocCode: buyMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.rtoDetails?.rtoLocationCode
            ? `${buyMotorPolicy?.vehicleTabDetails?.vehicleDetails?.rtoDetails?.rtoLocationCode}`
            : '',
          rtoLocDesc: buyMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.rtoDetails?.rtoLocationDesc
            ? `${buyMotorPolicy?.vehicleTabDetails?.vehicleDetails?.rtoDetails?.rtoLocationDesc}`
            : '',
        },
        vehicle: {
          make: buyMotorPolicy?.vehicleTabDetails?.vehicleDetails
            ?.make?.code
            ? `${buyMotorPolicy?.vehicleTabDetails?.vehicleDetails?.make?.code}`
            : '',
          model: buyMotorPolicy?.vehicleTabDetails?.vehicleDetails
            ?.model?.code
            ? `${buyMotorPolicy?.vehicleTabDetails?.vehicleDetails?.model?.code}`
            : '',
          variant: buyMotorPolicy?.vehicleTabDetails?.vehicleDetails
            ?.variant?.code
            ? `${buyMotorPolicy?.vehicleTabDetails?.vehicleDetails?.variant?.code}`
            : '',
          engineNumber: buyMotorPolicy?.vehicleTabDetails
            ?.vehicleRegistrationDetails?.engineNumber
            ? `${buyMotorPolicy?.vehicleTabDetails?.vehicleRegistrationDetails?.engineNumber}`
            : '',
          chasisNumber: buyMotorPolicy?.vehicleTabDetails
            ?.vehicleRegistrationDetails?.chasisNumber
            ? `${buyMotorPolicy?.vehicleTabDetails?.vehicleRegistrationDetails?.chasisNumber}`
            : '',
            preInspectionNumber: buyMotorPolicy?.vehicleTabDetails
            ?.vehicleRegistrationDetails?.preInspectionNumber
            ? `${buyMotorPolicy?.vehicleTabDetails?.vehicleRegistrationDetails?.preInspectionNumber}`
            : '',
          registrationNumber: buyMotorPolicy?.vehicleTabDetails
            ?.vehicleRegistrationDetails?.registrationNumber
            ? `${buyMotorPolicy?.vehicleTabDetails?.vehicleRegistrationDetails?.registrationNumber}`
            : '',
            registrationNumberOthers:buyMotorPolicy?.vehicleTabDetails
            ?.vehicleRegistrationDetails?.registrationNumberOthers
            ? `${buyMotorPolicy?.vehicleTabDetails?.vehicleRegistrationDetails?.registrationNumberOthers}`
            : '',
          manufactureYear: buyMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.yearOfManufacture
            ? `${buyMotorPolicy?.vehicleTabDetails?.vehicleDetails?.yearOfManufacture}`
            : '',
          regPurchaseDate: buyMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.dateOfRegistration
            ? `${buyMotorPolicy?.vehicleTabDetails?.vehicleDetails?.dateOfRegistration}`
            : '',
          fuelType: buyMotorPolicy?.vehicleTabDetails?.vehicleDetails
            ?.fuelType
            ? `${buyMotorPolicy?.vehicleTabDetails?.vehicleDetails?.fuelType}`
            : '',
          seatingCapacity: buyMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.seatingCapacity
            ? `${buyMotorPolicy?.vehicleTabDetails?.vehicleDetails?.seatingCapacity}`
            : '',
          cubicCapacity: buyMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.cubeCapacity
            ? `${buyMotorPolicy?.vehicleTabDetails?.vehicleDetails?.cubeCapacity}`
            : '',
            vehicleuse:buyMotorPolicy?.quoteData?.vehicleuse?.code
            ? `${buyMotorPolicy?.quoteData?.vehicleuse?.code}`
            : '',
            typeOfMiscVehicle:buyMotorPolicy?.quoteData?.typeOfMiscVehicle?.code
            ? `${buyMotorPolicy?.quoteData?.typeOfMiscVehicle?.code}`
            : '',
            carryingCapacity:buyMotorPolicy?.quoteData?.carryingCapacity
            ? `${buyMotorPolicy?.quoteData?.carryingCapacity}`
            : '',
            gvw:buyMotorPolicy?.quoteData?.changedGVW
            ? `${buyMotorPolicy?.quoteData?.changedGVW}`
            :buyMotorPolicy?.quoteData?.gvw,
            carriageType:buyMotorPolicy?.quoteData?.carriageType?.code
            ? `${buyMotorPolicy?.quoteData?.carriageType?.code}`
            : '',
            permitType:buyMotorPolicy?.quoteData?.permitType?.code
          
            ? `${buyMotorPolicy?.quoteData?.permitType?.code}`
            : '',
            vehicleuse:buyMotorPolicy?.quoteData?.vehicleuse?.code
            ? `${buyMotorPolicy?.quoteData?.vehicleuse?.code}`
            : '',
            vehiclesubType:buyMotorPolicy?.quoteData?.vehiclesubType?.code
            ? `${buyMotorPolicy?.quoteData?.vehiclesubType?.code}`
            : '',
        },
        firstYearIDV:
          buyMotorPolicy?.vehicleTabDetails?.insuredDeclaredDetails
            ?.vehicleIDV !== null &&
          buyMotorPolicy?.vehicleTabDetails?.insuredDeclaredDetails
            ?.vehicleIDV !== undefined
            ? `${buyMotorPolicy?.vehicleTabDetails?.insuredDeclaredDetails?.vehicleIDV}`
            : ``,
        irf1: buyMotorPolicy?.vehicleTabDetails
          ?.insuredDeclaredDetails?.irfAdjustmentPercent
          ? `${buyMotorPolicy?.vehicleTabDetails?.insuredDeclaredDetails?.irfAdjustmentPercent}`
          : '',
        prevInsurance: {
          coverType: buyMotorPolicy?.quoteData?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
        'yes'&&
          buyMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousPolicyDetails
            ?.policyCoverType
            ? `${buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyCoverType}`
            : '',
          policyTenure: buyMotorPolicy?.quoteData?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
          'yes'&&
          buyMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousPolicyDetails
            ?.policyTenure
            ? `${buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenure}`
            : '',
          insurerName: buyMotorPolicy?.quoteData?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
          'yes'&&
          buyMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousPolicyDetails
            ?.previousInsurerName
            ? `${buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.previousInsurerName}`
            : '',
          policyNumber: buyMotorPolicy?.quoteData?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
          'yes'&&
          buyMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousPolicyDetails
            ?.expiringPolicyNumber
            ? `${buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.expiringPolicyNumber}`
            : '',
          startDate:
          buyMotorPolicy?.quoteData?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
        'yes'&& buyMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousPolicyDetails
            ?.policyStartDate
            ? `${buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyStartDate}`
            : '',
          expiryDate:
          buyMotorPolicy?.quoteData?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
        'yes'&& buyMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousPolicyDetails
            ?.policyExpiryDate
            ? `${buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyExpiryDate}`
            : '',
          PypPolicyTenureTP:buyMotorPolicy?.quoteData?.TP_Policy_Tenure
            ? buyMotorPolicy?.quoteData?.TP_Policy_Tenure
            :'',
          PypStartDateTP:buyMotorPolicy?.quoteData?.TP_Start_Date
          ? buyMotorPolicy?.quoteData?.TP_Start_Date
          :'',
          PypEndDateTP:buyMotorPolicy?.quoteData?.TP_End_Date
          ? buyMotorPolicy?.quoteData?.TP_End_Date
          :'',
          PypInsurerTP:buyMotorPolicy?.additionalTabDetails
          ?.previousInsuranceAndClaims?.previousPolicyDetails
          ?.TPpreviousInsurerName !== null
          ? buyMotorPolicy?.additionalTabDetails
          ?.previousInsuranceAndClaims?.previousPolicyDetails
          ?.TPpreviousInsurerName
          :'',
          TPPolicyNo: buyMotorPolicy?.additionalTabDetails
          ?.previousInsuranceAndClaims?.previousPolicyDetails
          ?.TPexpiringPolicyNumber !== null
          ? buyMotorPolicy?.additionalTabDetails
          ?.previousInsuranceAndClaims?.previousPolicyDetails
          ?.TPexpiringPolicyNumber
            : '',
        },
        prevClaims: {
          totalClaimCount:
          buyMotorPolicy?.quoteData?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
        'yes'&&
              buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.totalClaimCount 
              ? `${buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.totalClaimCount}`
              : '',
          claimsInYear1:
          buyMotorPolicy?.quoteData?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
        'yes'&&
                 buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.noOfClaimsYear1
              ? `${buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.noOfClaimsYear1}`
              : '',
          claimsInYear2:
          buyMotorPolicy?.quoteData?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
        'yes'&&
          buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.noOfClaimsYear2
              ? `${buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.noOfClaimsYear2}`
              : '',
          claimsInYear3:
          buyMotorPolicy?.quoteData?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
        'yes'&&
          buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.noOfClaimsYear3
              ? `${buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.noOfClaimsYear3}`
              : '',
          prevNCBSlab:buyMotorPolicy?.quoteData?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
            'yes'?
           `${buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.previousYearNCBSlab}`
           :'',
          claimFreeYear:buyMotorPolicy?.quoteData?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
          'yes'&&
            buyMotorPolicy?.quoteData?.premiumData?.claimFreeYear ||
            buyMotorPolicy?.premiumData?.claimFreeYear,
          totalClaimAmount:
          buyMotorPolicy?.quoteData?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
        'yes'&&
            buyMotorPolicy?.additionalTabDetails
              ?.previousInsuranceAndClaims?.previousClaims
              ?.totalClaimAmount !== undefined &&
            buyMotorPolicy?.additionalTabDetails
              ?.previousInsuranceAndClaims?.previousClaims
              ?.totalClaimAmount !== null
              ? parseFloat(
                  buyMotorPolicy?.additionalTabDetails
                    ?.previousInsuranceAndClaims?.previousClaims
                    ?.totalClaimAmount,
                )
              : null,
        },
        financerDetails: {
          financerName:
            buyMotorPolicy?.additionalTabDetails?.financeDetails?.vehicleOwned?.toLowerCase() ===
            'financed'
              ? buyMotorPolicy?.additionalTabDetails?.financeDetails
                  ?.financerDetails?.financerName
              : '',
          financerAddress:
            buyMotorPolicy?.additionalTabDetails?.financeDetails?.vehicleOwned?.toLowerCase() ===
            'financed'
              ? buyMotorPolicy?.additionalTabDetails?.financeDetails
                  ?.financerDetails?.financerAddress
              : '',
          financerAgreementType:
            buyMotorPolicy?.additionalTabDetails?.financeDetails?.vehicleOwned?.toLowerCase() ===
            'financed'
              ? buyMotorPolicy?.additionalTabDetails?.financeDetails
                  ?.financerDetails?.financerAgreementType
              : '',
          loanAccountNumber:
            buyMotorPolicy?.additionalTabDetails?.financeDetails?.vehicleOwned?.toLowerCase() ===
            'financed'
              ? buyMotorPolicy?.additionalTabDetails?.financeDetails
                  ?.financerDetails?.loanAccountNumber
              : '',
          fileNumber:
            buyMotorPolicy?.additionalTabDetails?.financeDetails?.vehicleOwned?.toLowerCase() ===
            'financed'
              ? buyMotorPolicy?.additionalTabDetails?.financeDetails
                  ?.financerDetails?.fileNumber
              : '',
        },
        trailerDetails:trailerArr,
        ownerDriverSelected:ownerDriverSelected,
        riskCovers: riskInput,
        creditScore: {
          discountOpted:
            buyMotorPolicy?.quoteData?.getAdditionalCreditScore ===
            'Yes',
          idProofType: buyMotorPolicy?.quoteData?.idProofType,
          idProofNumber: buyMotorPolicy?.quoteData?.idProofNumber,
          creditScore:
            buyMotorPolicy?.quoteData?.premiumData?.creditScore !==
              null &&
            buyMotorPolicy?.quoteData?.premiumData?.creditScore !==
              undefined
              ? parseFloat(
                  buyMotorPolicy?.quoteData?.premiumData?.creditScore,
                )
              : null,
        },
        proposerPincode: buyMotorPolicy?.proposerDetails?.permPincode,
        voluntaryDeductibleAmt:
          buyMotorPolicy?.quoteData?.voluntaryDeductibleAmount !==
            null &&
          buyMotorPolicy?.quoteData?.voluntaryDeductibleAmount !==
            undefined
            ? parseFloat(
                buyMotorPolicy?.quoteData?.voluntaryDeductibleAmount,
              )
            : null,
           NCB:
            buyMotorPolicy?.quoteData?.premiumData?.NCB !==
              null &&
            buyMotorPolicy?.quoteData?.premiumData?.NCB !==
              undefined
              ? parseFloat(
                  buyMotorPolicy?.quoteData?.premiumData?.NCB,
                )
              : null,
        quoteNumber: buyMotorPolicy?.quoteNumber,
        nomineeDetails: {
          name: ownerDriverSelected=='true'?
          buyMotorPolicy?.additionalTabDetails?.nomineeDetails
            ?.nomineeName:'',
          dob: 
          ownerDriverSelected=='true'?
          buyMotorPolicy?.additionalTabDetails?.nomineeDetails
            ?.nomineeDob:'',
          relationshipWithInsured:
          ownerDriverSelected=='true'?
            buyMotorPolicy?.additionalTabDetails?.nomineeDetails
              ?.relationshipWithNominee:'',
          nameOfAppointee:
          ownerDriverSelected=='true'?
            buyMotorPolicy?.additionalTabDetails?.nomineeDetails
              ?.nameOfAppointee:'',
          relationshipWithAppointee:
          ownerDriverSelected=='true'?
            buyMotorPolicy?.additionalTabDetails?.nomineeDetails
              ?.relationshipWithAppointee:''
        },
        customer: {
          id: buyMotorPolicy?.proposerDetails?.id,
          customerType: buyMotorPolicy?.proposerDetails?.customerType,
          isThinCustomer: false,
          title: buyMotorPolicy?.proposerDetails?.title,
          gender: buyMotorPolicy?.proposerDetails?.gender,
          firstName: buyMotorPolicy?.proposerDetails?.firstName,
          middleName: buyMotorPolicy?.proposerDetails?.middleName,
          lastName: buyMotorPolicy?.proposerDetails?.lastName,
          fullName: buyMotorPolicy?.proposerDetails?.fullName,
          proposerDOB: buyMotorPolicy?.proposerDetails?.proposerDOB,
          maritalStatus:
            buyMotorPolicy?.proposerDetails?.maritalStatus,
          occupation: buyMotorPolicy?.proposerDetails?.occupation,
          nationality: buyMotorPolicy?.proposerDetails?.nationality,
          idProofType: buyMotorPolicy?.proposerDetails?.idProofType,
          idProofNumber:
            buyMotorPolicy?.proposerDetails?.idProofNumber,
          panNumber: buyMotorPolicy?.proposerDetails?.panNumber,
          orgName: buyMotorPolicy?.proposerDetails?.orgName,
          orgType: buyMotorPolicy?.proposerDetails?.orgType,
          contactName: buyMotorPolicy?.proposerDetails?.contactName,
          regNumber: buyMotorPolicy?.proposerDetails?.regNumber,
          tanNumber: buyMotorPolicy?.proposerDetails?.tanNumber,
          gstNumber: buyMotorPolicy?.proposerDetails?.gstNumber,
          permAddressLine1:
            buyMotorPolicy?.proposerDetails?.permAddressLine1,
          permAddressLine2:
            buyMotorPolicy?.proposerDetails?.permAddressLine2,
          permAddressLine3:
            buyMotorPolicy?.proposerDetails?.permAddressLine3,
          permLandmark: buyMotorPolicy?.proposerDetails?.permLandmark,
          permPincode: buyMotorPolicy?.proposerDetails?.permPincode,
          permCityTownVillage:
            buyMotorPolicy?.proposerDetails?.permCityTownVillage,
          permDistrict: buyMotorPolicy?.proposerDetails?.permDistrict,
          permState: buyMotorPolicy?.proposerDetails?.permState,
          permCommAddressYN: buyMotorPolicy?.proposerDetails
            ?.permCommAddressYN
            ? true
            : false,
          commAddressLine1:
            buyMotorPolicy?.proposerDetails?.commAddressLine1,
          commAddressLine2:
            buyMotorPolicy?.proposerDetails?.commAddressLine2,
          commAddressLine3:
            buyMotorPolicy?.proposerDetails?.commAddressLine3,
          commLandmark: buyMotorPolicy?.proposerDetails?.commLandmark,
          commPincode: buyMotorPolicy?.proposerDetails?.commPincode,
          commCityTownVillage:
            buyMotorPolicy?.proposerDetails?.commCityTownVillage,
          commDistrict: buyMotorPolicy?.proposerDetails?.commDistrict,
          commState: buyMotorPolicy?.proposerDetails?.commState,
          phoneNo: buyMotorPolicy?.proposerDetails?.phoneNo,
          mobileNo: buyMotorPolicy?.proposerDetails?.mobileNo,
          emailID: buyMotorPolicy?.proposerDetails?.emailID,
          faxNo: buyMotorPolicy?.proposerDetails?.faxNo,
          altPhoneNo: buyMotorPolicy?.proposerDetails?.altPhoneNo,
          altMobileNo: buyMotorPolicy?.proposerDetails?.altMobileNo,
          ifscCode: buyMotorPolicy?.proposerDetailsMeta?.ifscCode,
          bankName: buyMotorPolicy?.proposerDetailsMeta?.bankName,
          branchName: buyMotorPolicy?.proposerDetailsMeta?.branchName,
          bankAcno: buyMotorPolicy?.proposerDetailsMeta?.bankAcno,
          accountHolderName:
            buyMotorPolicy?.proposerDetailsMeta?.accountHolderName,
          micrCode: buyMotorPolicy?.proposerDetailsMeta?.micrCode,
          employeeNumber:
            buyMotorPolicy?.proposerDetails?.employeeNumber,
          isCRNVerified: buyMotorPolicy?.proposerDetailsMeta?.isCRNVerified === null 
                ? false : buyMotorPolicy?.proposerDetailsMeta?.isCRNVerified,
          crn: buyMotorPolicy?.proposerDetailsMeta?.crn,
          /*SADivya : CR P2_233 : KYC */
         motherMaidenName: buyMotorPolicy?.proposerDetails?.motherMaidenName,
         ckycIdNumber: buyMotorPolicy?.proposerDetails?.ckycIdNumber,
         eiaRequired:buyMotorPolicy?.proposerDetails?.eiaRequired,
         eiaNumber:buyMotorPolicy?.proposerDetails?.eiaNumber,
         certificateOfInCorporation: buyMotorPolicy?.proposerDetails?.certificateOfInCorporation,
         udyogAadhaarNumber: buyMotorPolicy?.proposerDetails?.udyogAadhaarNumber,
       /*EADivya : CR P2_233 :KYC */
       /**SADivya : CR498 : PAN Mandatory */
          form60: buyMotorPolicy?.proposerDetails?.form60?.toString()?.toLowerCase() === 'true'
            ? true : false,
          dateOfIncorporation: buyMotorPolicy?.proposerDetails?.dateOfIncorporation,
        },
        leadGenerator: values?.leadGenerator,
        proposalPaymentType: values?.proposalPaymentType,
      },
    };
  };
  const onSubmit = async (values,{setFieldValue}) => {
    if (!buyMotorPolicy?.proposalNumber || buyMotorPolicy?.isProposalModify)  {
      try {
        setParentAlerts([]);
        const saveProposalMutation = mutateQuery({
          mutation: SAVE_PROPOSAL_MISCD,
          variables: getSaveProposalMutationVariables(values),
        });
        window.scrollTo({ top: 0, behavior: 'smooth' });
        updateBuyMotorPolicy({
          reviewAndConfirmTabDetails: values,
        });
        setLoadingStep(true);
        setCustomLoadingMessage('Saving Proposal');
        const { data } = await saveProposalMutation;
        setLoadingStep(false);
        setCustomLoadingMessage(null);
       //if (data?.MISCDsaveProposal?.Error?.includes("VehicleInspectionNeeded: True")){
        if (data?.MISCDsaveProposal?.VehicleInspectionNeeded){
          setFieldValue('preinspectionDetails.isVehicleInspectionNeeded',true)
          updateBuyMotorPolicy({
            preinspectionDetails:{isVehicleInspectionNeeded: true},
          });
        }
        if (data?.MISCDsaveProposal?.warningMsg) {
          setParentAlerts([
            {
              header: 'Proposal Saved Successfully',
              content: (
                <div className="flex flex-col w-full h-full">
                  <Text type="normal">
                    <FontAwesomeIcon
                      icon={faCheck}
                      className="text-success"
                    />{' '}
                    Proposal Number:{' '}
                    {data?.MISCDsaveProposal?.proposalNumber}
                  </Text>
                </div>
              ),
              type: 'success',
              timeout: null,
              disableClose: false,
            },
            {
              content: (
                <Text type="normal">
                  {data?.MISCDsaveProposal?.warningMsg}
                </Text>
              ),
              type: 'warning',
              timeout: null,
              disableClose: false,
            },
          ]);
        } else {
          setParentAlerts([
            {
              header: 'Proposal Saved Successfully',
              id: Date.now(),
              content: (
                <div className="flex flex-col w-full h-full">
                  <Text type="normal">
                    <FontAwesomeIcon
                      icon={faCheck}
                      className="text-success"
                    />{' '}
                    Proposal Number:{' '}
                    {data?.MISCDsaveProposal?.proposalNumber}
                  </Text>
                </div>
              ),
              type: 'success',
              timeout: null,
              disableClose: false,
            },
          ]);
        }
        updateBuyMotorPolicy({
          reviewAndConfirmTabDetails: {
            ...values,
            isProposalCreated: true,
          },
          isProposalModify:false,
          proposalNumber: data?.MISCDsaveProposal?.proposalNumber,
          proposalStatus: data?.MISCDsaveProposal?.proposalStatus,
          isProposalApplicableForPayment:
            data?.MISCDsaveProposal?.isApplicableForPayment === null ||
            data?.MISCDsaveProposal?.isApplicableForPayment ===
              undefined ||
            data?.MISCDsaveProposal?.isApplicableForPayment
              ? true
              : false,
          policy: {
            startDate: buyMotorPolicy?.policy?.startDate
            ? buyMotorPolicy?.policy?.startDate
            : datetimeValue?.date
            ? datetimeValue?.date
            : moment(new Date(), 'DD/MM/YYYY'),
            endDate: data?.MISCDsaveProposal?.proposalEndDate,
            time: datetimeValue?.time,
          },
          proposerDetails: {
            id: data?.MISCDsaveProposal?.customerID,
          },
    //      premiumData: data?.MISCDsaveProposal?.premium,
          premiumData: {
            ...data?.MISCDsaveProposal?.premium,
            discount : data?.MISCDsaveProposal?.premium?.discount?.length > 0 
                      ? data?.MISCDsaveProposal?.premium?.discount 
                      : dataBuyMotorPolicy?.buyMotorPolicy?.premiumData?.discount?.length > 0 
                        ? dataBuyMotorPolicy?.buyMotorPolicy?.premiumData?.discount
                        : [],
          },
        });
        return true;
      } catch (error) {
        //SA radhika
        if(error?.message){
          if(error.message.includes("Unexpected token")){
            error.message='Please try again after sometime'
          }
        }
        //EA radhika
        setParentAlerts([
          {
            header: 'Error',
            id: Date.now(),
            content: (
              <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                {error.message}
              </div>
            ),
            type: 'error',
            timeout: null,
            disableClose: false,
          },
        ]);
        setLoadingStep(false);
        return false;
      }
    } else {
      return true;
    }
  };

  const ReviewAndConfirmForm = ({ validate }) => {
    const { values, setFieldValue } = useQuantaFormikContext();
    const repeatForDesktop = 3,
      repeatForMobile = 2;
    const MINOR_THRESHOLD_AGE = 18;

    const repeat = useResponsiveParams({
      for_mobile: repeatForMobile,
      for_desktop: repeatForDesktop,
    });

    const screenType = useResponsiveParams({
      for_mobile: 'mobile',
      for_desktop: 'desktop',
    });
    const reviewAndConfirmData = [
      {
        title: 'Review Proposal',
        grid_type: 'data',
        grid_data: [
          {
            label: 'Product Name',
            colSpan: repeat === repeatForMobile ? 2 : 1,
            text: productName,
          },
          {
            label: 'Business Type',
            text: buyMotorPolicy?.quoteData?.businessTypeValue
              ? buyMotorPolicy?.quoteData?.businessTypeValue
              : buyMotorPolicy?.quoteData?.businessType,
          },
          {
            label: 'Policy Start Date',
            text: buyMotorPolicy?.policy?.startDate
              ? buyMotorPolicy?.policy?.startDate
              : datetimeValue?.date
              ? datetimeValue?.date
              : moment(new Date(), 'DD/MM/YYYY'),
          },
          {
            label: 'Total IDV',
            text:
              buyMotorPolicy?.vehicleTabDetails
                ?.insuredDeclaredDetails?.vehicleIDV !== null
                ? CurrencyFormater(
                  `${buyMotorPolicy?.quoteData?.totalIDV!=='NaN'
                  && buyMotorPolicy?.quoteData?.totalIDV!=='' 
                  ?buyMotorPolicy?.quoteData?.totalIDV
                  :buyMotorPolicy?.quoteData?.bodyIDV !==''&&
                  buyMotorPolicy?.quoteData?.bodyIDV !=='NaN'
                 ? (parseFloat(buyMotorPolicy?.vehicleTabDetails?.insuredDeclaredDetails?.vehicleIDV)
                  +parseFloat(buyMotorPolicy?.quoteData?.bodyIDV))
                  :buyMotorPolicy?.vehicleTabDetails?.insuredDeclaredDetails?.vehicleIDV
                }`,
                    true,
                    false,
                    branding,
                  )
                : '',
          },
          {
            label: 'Chasis IDV',
            text:
            buyMotorPolicy?.quoteData?.productVariant?.toLowerCase()?.search('liability') !== -1
            ? 0
             : buyMotorPolicy?.vehicleTabDetails
                ?.insuredDeclaredDetails?.vehicleIDV !== null&&buyMotorPolicy?.vehicleTabDetails
                ?.insuredDeclaredDetails?.vehicleIDV !== ''
                ? CurrencyFormater(
                    `${(parseFloat(buyMotorPolicy?.vehicleTabDetails?.insuredDeclaredDetails?.vehicleIDV))}`,
                    true,
                    false,
                    branding,
                  )
                : '',
          },
          {
            label: 'Body IDV',
            text:
            buyMotorPolicy?.quoteData?.productVariant?.toLowerCase()?.search('liability') !== -1
            ? 0
              :buyMotorPolicy?.vehicleTabDetails
                ?.insuredDeclaredDetails?.vehicleIDV !== null
                ? CurrencyFormater(
                    `${buyMotorPolicy?.quoteData?.bodyIDV
                    ?buyMotorPolicy?.quoteData?.bodyIDV
                  :0}`,
                    true,
                    false,
                    branding,
                  )
                : '',
          },
          {
            label: 'IRF1 Adjustment',
            text: buyMotorPolicy?.vehicleTabDetails
              ?.insuredDeclaredDetails?.irfAdjustmentPercent
              ? `${buyMotorPolicy?.vehicleTabDetails?.insuredDeclaredDetails?.irfAdjustmentPercent} %`
              : '',
          },
          {
            label: 'Tenure',
            text:
              buyMotorPolicy?.quoteData?.tenure ||
              buyMotorPolicy?.quoteData?.premiumData?.tenure
                ? `${
                    buyMotorPolicy?.quoteData?.tenure ||
                    buyMotorPolicy?.quoteData?.premiumData?.tenure
                  } ${
                    (
                      buyMotorPolicy?.quoteData?.tenure ||
                      buyMotorPolicy?.quoteData?.premiumData?.tenure
                    )?.trim() === '1'
                      ? 'year'
                      : 'years'
                  }`
                : '',
          },
          {
            label: 'Credit Score Discount',
            text:
              buyMotorPolicy?.quoteData?.getAdditionalCreditScore?.toLowerCase() ===
              'no'
                ? 'Not Availed'
                : 'Availed',
          },
          // buyMotorPolicy?.quoteData?.voluntaryDeductibleAmount !==
          //   null &&
          // buyMotorPolicy?.quoteData?.voluntaryDeductibleAmount !==
          //   undefined &&
          // buyMotorPolicy?.quoteData?.voluntaryDeductibleAmount !== ''
          //   ? {
          //       label: 'Voluntary Deductible Amount',
          //       colSpan:
          //         screenType?.toString()?.toLowerCase() === 'mobile'
          //           ? repeat
          //           : 1,
          //       text: CurrencyFormater(
          //         buyMotorPolicy?.quoteData
          //           ?.voluntaryDeductibleAmount,
          //         true,
          //         false,
          //         branding,
          //         true,
          //       ),
          //     }
          //   : null,
          {
            label: 'Proposal Type',
            colSpan:
              (buyMotorPolicy?.quoteData
                ?.voluntaryDeductibleAmount === null ||
                buyMotorPolicy?.quoteData
                  ?.voluntaryDeductibleAmount === undefined ||
                buyMotorPolicy?.quoteData
                  ?.voluntaryDeductibleAmount === '') &&
              repeat === repeatForDesktop
                ? 2
                : 1,
            text: (
              <QuantaRadioGroup
                name={'proposalPaymentType'}
                className={'mt-1'}
                disabledGlobal={
                  buyMotorPolicy?.proposalNumber?.length > 0
                  && !buyMotorPolicy?.isProposalModify
                }
                data={
                  ProposalPaymentTypeList &&
                  ProposalPaymentTypeList?.length > 0
                    ? ProposalPaymentTypeList?.map(
                        (proposalPaymentType) => {
                          return {
                            label: proposalPaymentType?.value
                              ? proposalPaymentType?.value
                              : '',
                            value: proposalPaymentType?.code
                              ? proposalPaymentType?.code
                              : '',
                          };
                        },
                      )
                    : []
                }
              />
            ),
          },
          {
            label: 'Lead Generator',
            colSpan: repeat === repeatForMobile ? 2 : 1,
            text: (
              <div className={'mt-1'}>
                <QuantaInput
                  type={'text'}
                  size={'full'}
                  name={'leadGenerator'}
                  disabled={   buyMotorPolicy?.proposalNumber?.length > 0   
                    && !buyMotorPolicy?.isProposalModify
                  }
                />
              </div>
            ),
          },
        ]?.filter((d) => d),
      },
    ];

    // const proposerDetailsData = [
    //   buyMotorPolicy?.proposerDetailsMeta?.isNewCustomer === false
    //     ? {
    //         grid_type: 'data',
    //         grid_data: [
    //           {
    //             label: 'Customer Number',
    //             text: buyMotorPolicy?.proposerDetails?.id,
    //           },
    //           {
    //             label: 'CRN',
    //             text: buyMotorPolicy?.proposerDetailsMeta?.crn,
    //           },
    //         ],
    //       }
    //     : null,
    //   buyMotorPolicy?.proposerDetails?.customerType ===
    //   getDomainData(customerTypeList, 'Individual', 'value', 'code')
    //     ? {
    //         title: <Text type="normal">Personal Details</Text>,
    //         grid_type: 'data',
    //         isBorderRequired: true,
    //         borderClassName: 'border-t-2 border-neutral pt-4',
    //         grid_data: [
    //           {
    //             label: 'Title',
    //             text: (
    //               <span>
    //                 {buyMotorPolicy?.proposerDetails?.title !== ''
    //                   ? getDomainData(
    //                       salutationList,
    //                       buyMotorPolicy?.proposerDetails?.title,
    //                       'code',
    //                       'value',
    //                     )
    //                   : ''}
    //               </span>
    //             ),
    //           },
    //           {
    //             label: 'Gender',
    //             text: (
    //               <span>
    //                 {buyMotorPolicy?.proposerDetails?.gender !== ''
    //                   ? getDomainData(
    //                       genderList,
    //                       buyMotorPolicy?.proposerDetails?.gender,
    //                       'code',
    //                       'value',
    //                     )
    //                   : ''}
    //               </span>
    //             ),
    //           },
    //           {
    //             label: 'Date of Birth',
    //             text: buyMotorPolicy?.proposerDetails?.proposerDOB,
    //           },
    //           {
    //             label: 'First Name',
    //             text: buyMotorPolicy?.proposerDetails?.firstName,
    //           },
    //           {
    //             label: 'Middle Name',
    //             text: buyMotorPolicy?.proposerDetails?.middleName,
    //           },
    //           {
    //             label: 'Last Name',
    //             text: buyMotorPolicy?.proposerDetails?.lastName,
    //           },
    //           {
    //             label: 'Marital Status',
    //             text: (
    //               <span>
    //                 {buyMotorPolicy?.proposerDetails
    //                   ?.maritalStatus !== ''
    //                   ? getDomainData(
    //                       maritalStatusList,
    //                       buyMotorPolicy?.proposerDetails
    //                         ?.maritalStatus,
    //                       'code',
    //                       'value',
    //                     )
    //                   : ''}
    //               </span>
    //             ),
    //           },
    //           {
    //             label: 'Nationality',
    //             text: (
    //               <span>
    //                 {buyMotorPolicy?.proposerDetails?.nationality !==
    //                 ''
    //                   ? getDomainData(
    //                       nationalityList,
    //                       buyMotorPolicy?.proposerDetails
    //                         ?.nationality,
    //                       'code',
    //                       'value',
    //                     )
    //                   : ''}
    //               </span>
    //             ),
    //           },
    //         ],
    //       }
    //     : {
    //         title: <Text type="normal">Organisation Details</Text>,
    //         grid_type: 'data',
    //         isBorderRequired: true,
    //         borderClassName: 'border-t-2 border-neutral pt-4',
    //         grid_data: [
    //           {
    //             label: 'Organisation Name',
    //             text: buyMotorPolicy?.proposerDetails?.orgName,
    //           },
    //           {
    //             label: 'Organisation Type ',
    //             text: getDomainData(
    //               organisationList,
    //               buyMotorPolicy?.proposerDetails?.orgType,
    //               'code',
    //               'value',
    //             ),
    //           },
    //           {
    //             label: 'Contact Person Name',
    //             text: buyMotorPolicy?.proposerDetails?.contactName,
    //           },
    //         ],
    //       },
    //   buyMotorPolicy?.proposerDetails?.customerType ===
    //   getDomainData(customerTypeList, 'Individual', 'value', 'code')
    //     ? {
    //         title: <Text type="normal">Identification Details</Text>,
    //         grid_type: 'data',
    //         isBorderRequired: true,
    //         borderClassName: 'border-t-2 border-neutral pt-4',
    //         grid_data: [
    //           {
    //             label: 'ID Proof Type',
    //             text: (
    //               <span>
    //                 {buyMotorPolicy?.proposerDetails?.idProofType !==
    //                 ''
    //                   ? getDomainData(
    //                       idProofTypeList,
    //                       buyMotorPolicy?.proposerDetails
    //                         ?.idProofType,
    //                       'code',
    //                       'value',
    //                     )
    //                   : ''}
    //               </span>
    //             ),
    //           },
    //           {
    //             label: 'ID Proof Number',
    //             text: buyMotorPolicy?.proposerDetails?.idProofNumber
    //               ?.toString()
    //               ?.toUpperCase(),
    //           },
    //         ],
    //       }
    //     : {
    //         title: (
    //           <Text type="normal">Tax Identification Details</Text>
    //         ),
    //         grid_type: 'data',
    //         isBorderRequired: true,
    //         borderClassName: 'border-t-2 border-neutral pt-4',
    //         grid_data: [
    //           {
    //             label: 'Registration Number',
    //             text: buyMotorPolicy?.proposerDetails?.regNumber,
    //           },
    //           {
    //             label: 'TAN Number',
    //             text: buyMotorPolicy?.proposerDetails?.tanNumber?.toUpperCase(),
    //           },
    //           {
    //             label: 'GST Number',
    //             text: buyMotorPolicy?.proposerDetails?.gstNumber?.toUpperCase(),
    //           },
    //         ],
    //       },
    //   buyMotorPolicy?.proposerDetails?.customerType ===
    //   getDomainData(customerTypeList, 'Individual', 'value', 'code')
    //     ? {
    //         title: <Text type="normal">Internal Employee</Text>,
    //         grid_type: 'data',
    //         isBorderRequired: true,
    //         borderClassName: 'border-t-2 border-neutral pt-4',
    //         grid_data: [
    //           {
    //             label: 'Employee Number',
    //             text: buyMotorPolicy?.proposerDetails?.employeeNumber
    //               ?.toString()
    //               ?.toUpperCase(),
    //           },
    //         ],
    //       }
    //     : null,
    //   buyMotorPolicy?.proposerDetails?.customerType ===
    //   getDomainData(customerTypeList, 'Individual', 'value', 'code')
    //     ? {
    //         title: (
    //           <Text type="normal">Tax Identification Details</Text>
    //         ),
    //         grid_type: 'data',
    //         isBorderRequired: true,
    //         borderClassName: 'border-t-2 border-neutral pt-4',
    //         grid_data: [
    //           {
    //             label: 'PAN Card Number',
    //             text: buyMotorPolicy?.proposerDetails?.panNumber
    //               ?.toString()
    //               ?.toUpperCase(),
    //           },
    //           {
    //             label: 'GST Number',
    //             text: buyMotorPolicy?.proposerDetails?.gstNumber?.toUpperCase(),
    //           },
    //         ],
    //       }
    //     : null,
    //   {
    //     grid_type: 'data',
    //     isBorderRequired: true,
    //     borderClassName: 'border-t-2 border-neutral pt-4',
    //     grid_data: [
    //       {
    //         label: 'Permanent Address',
    //         colSpan: repeat,
    //         text: [
    //           buyMotorPolicy?.proposerDetails?.permAddressLine1?.trim(),
    //           buyMotorPolicy?.proposerDetails?.permAddressLine2?.trim(),
    //           buyMotorPolicy?.proposerDetails?.permAddressLine3?.trim(),
    //           buyMotorPolicy?.proposerDetails?.permLandmark?.trim(),
    //           buyMotorPolicy?.proposerDetails?.permCityTownVillage?.trim(),
    //           buyMotorPolicy?.proposerDetails?.permDistrict?.trim(),
    //           buyMotorPolicy?.proposerDetails?.permState?.trim(),
    //           buyMotorPolicy?.proposerDetails?.permPincode,
    //         ]
    //           .filter((a) => a)
    //           .join(','),
    //       },
    //       {
    //         label: 'Communication Address',
    //         colSpan: repeat,
    //         text: [
    //           buyMotorPolicy?.proposerDetails?.commAddressLine1?.trim(),
    //           buyMotorPolicy?.proposerDetails?.commAddressLine2?.trim(),
    //           buyMotorPolicy?.proposerDetails?.commAddressLine3?.trim(),
    //           buyMotorPolicy?.proposerDetails?.commLandmark?.trim(),
    //           buyMotorPolicy?.proposerDetails?.commCityTownVillage?.trim(),
    //           buyMotorPolicy?.proposerDetails?.commDistrict?.trim(),
    //           buyMotorPolicy?.proposerDetails?.commState?.trim(),
    //           buyMotorPolicy?.proposerDetails?.commPincode,
    //         ]
    //           .filter((a) => a)
    //           .join(','),
    //       },
    //     ].filter((d) => d),
    //   },
    //   buyMotorPolicy?.proposerDetails?.customerType ===
    //   getDomainData(customerTypeList, 'Individual', 'value', 'code')
    //     ? {
    //         title: <Text type="normal">Contact Details</Text>,
    //         grid_type: 'data',
    //         isBorderRequired: true,
    //         borderClassName: 'border-t-2 border-neutral pt-4',
    //         grid_data: [
    //           {
    //             label: 'Mobile Number',
    //             text: buyMotorPolicy?.proposerDetails?.mobileNo,
    //           },
    //           {
    //             label: 'Email Id',
    //             text: buyMotorPolicy?.proposerDetails?.emailID,
    //           },
    //           !buyMotorPolicy?.proposalNumber
    //             ? {
    //                 colSpan: repeat,
    //                 label: <div className="mt-4"></div>,
    //                 text: (
    //                   <Text
    //                     severity="action"
    //                     className="hover:underline cursor-pointer"
    //                     onClick={(_) => {
    //                       goToStep(0);
    //                       window.scrollTo({
    //                         top: 0,
    //                         behavior: 'smooth',
    //                       });
    //                     }}
    //                   >
    //                     <FontAwesomeIcon
    //                       icon={faEdit}
    //                       className="mr-1"
    //                     />
    //                     <span className="font-bold">
    //                       Edit Details
    //                     </span>
    //                   </Text>
    //                 ),
    //               }
    //             : null,
    //         ].filter((d) => d),
    //       }
    //     : {
    //         title: <Text type="normal">Contact Details</Text>,
    //         grid_type: 'data',
    //         isBorderRequired: true,
    //         borderClassName: 'border-t-2 border-neutral pt-4',
    //         grid_data: [
    //           {
    //             label: 'Telephone Number',
    //             text: buyMotorPolicy?.proposerDetails?.phoneNo,
    //           },
    //           {
    //             label: 'Organisation Mobile Number',
    //             text: buyMotorPolicy?.proposerDetails?.mobileNo,
    //           },
    //           {
    //             label: 'FAX Number',
    //             text: buyMotorPolicy?.proposerDetails?.faxNo,
    //           },
    //           {
    //             label: 'Alternative Telephone Number',
    //             text: buyMotorPolicy?.proposerDetails?.altPhoneNo,
    //           },
    //           {
    //             label: 'Alternative Mobile Number',
    //             text: buyMotorPolicy?.proposerDetails?.altMobileNo,
    //           },
    //           {
    //             label: 'Organisation Email Id',
    //             text: buyMotorPolicy?.proposerDetails?.emailID,
    //           },
    //           !buyMotorPolicy?.proposalNumber
    //             ? {
    //                 colSpan: repeat,
    //                 label: <div className="mt-4"></div>,
    //                 text: (
    //                   <Text
    //                     severity="action"
    //                     className="hover:underline cursor-pointer"
    //                     onClick={(_) => {
    //                       goToStep(0);
    //                       window.scrollTo({
    //                         top: 0,
    //                         behavior: 'smooth',
    //                       });
    //                     }}
    //                   >
    //                     <FontAwesomeIcon
    //                       icon={faEdit}
    //                       className="mr-1"
    //                     />
    //                     <span className="font-bold">
    //                       Edit Details
    //                     </span>
    //                   </Text>
    //                 ),
    //               }
    //             : null,
    //         ].filter((d) => d),
    //       },
    // ].filter((d) => d);

    const vehicleDetailsData = [
      {
        grid_type: 'data',
        grid_data: [
          {
            label: 'Make',
            text: buyMotorPolicy?.vehicleTabDetails?.vehicleDetails
              ?.make?.value,
          },
          {
            label: 'Model',
            text: buyMotorPolicy?.vehicleTabDetails?.vehicleDetails
              ?.model?.value,
          },
          {
            label: 'Variant',
            text: buyMotorPolicy?.vehicleTabDetails?.vehicleDetails
              ?.variant?.value,
          },
          {
            label: 'Fuel Type',
            text: buyMotorPolicy?.vehicleTabDetails?.vehicleDetails
              ?.fuelType,
          },
          {
            label: 'Cubic Capacity',
            text: buyMotorPolicy?.vehicleTabDetails?.vehicleDetails
              ?.cubeCapacity,
          },
          {
            label: 'Seating Capacity',
            text: buyMotorPolicy?.vehicleTabDetails?.vehicleDetails
              ?.seatingCapacity,
          },
          {
            label: 'Year of Manufacture',
            text: buyMotorPolicy?.vehicleTabDetails?.vehicleDetails
              ?.yearOfManufacture,
          },
          {
            label: 'RTO Code (Location)',
            text: `${buyMotorPolicy?.vehicleTabDetails?.vehicleDetails?.rtoDetails?.rtoAuthorityCode}-${buyMotorPolicy?.vehicleTabDetails?.vehicleDetails?.rtoDetails?.rtoLocationDesc}`,
          },
          {
            label: 'Date of Registration/Invoice',
            text: buyMotorPolicy?.vehicleTabDetails?.vehicleDetails
              ?.dateOfRegistration,
          },
          {
            label: 'Registration Number',
            text: buyMotorPolicy?.vehicleTabDetails
              ?.vehicleRegistrationDetails?.registrationNumber,
          },
          {
            label: 'Engine Number',
            text: buyMotorPolicy?.vehicleTabDetails
              ?.vehicleRegistrationDetails?.engineNumber,
          },
          {
            label: 'Chassis Number',
            text: buyMotorPolicy?.vehicleTabDetails
              ?.vehicleRegistrationDetails?.chasisNumber,
          },
          {
            label: 'Pre Inspection Number',
            text: buyMotorPolicy?.vehicleTabDetails
              ?.vehicleRegistrationDetails?.preInspectionNumber !=''
              ?buyMotorPolicy?.vehicleTabDetails
              ?.vehicleRegistrationDetails?.preInspectionNumber
              :'NA',
          },
          !buyMotorPolicy?.proposalNumber
            ? {
                colSpan: repeat,
                className: 'mt-2',
                text: (
                  <Text
                    severity="action"
                    className="hover:underline cursor-pointer"
                    onClick={(_) => {
                      goToStep(1);
                      window.scrollTo({
                        top: 0,
                        behavior: 'smooth',
                      });
                    }}
                  >
                    <FontAwesomeIcon icon={faEdit} className="mr-1" />
                    <Text className="font-bold">Edit Details</Text>
                  </Text>
                ),
              }
            : null,
        ].filter((d) => d),
      },
    ];

    const prevInsuranceAndClaimsData = [
      {
        grid_type: 'data',
        title: 'Previous Policy',
        grid_data: [
          {
            label: 'Previous Insurer Name',
            text: buyMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousPolicyDetails
            ?.previousInsurerName,
            // getDomainData(
            //   rolloverCompanyList,
            //   buyMotorPolicy?.additionalTabDetails
            //     ?.previousInsuranceAndClaims?.previousPolicyDetails
            //     ?.previousInsurerName,
            //   'code',
            //   'value',
            // ),
          },
          {
            label: 'Expiring Policy Number',
            text: buyMotorPolicy?.additionalTabDetails
              ?.previousInsuranceAndClaims?.previousPolicyDetails
              ?.expiringPolicyNumber,
          },
          {
            label: 'Policy/Cover Type',
            text: buyMotorPolicy?.additionalTabDetails
              ?.previousInsuranceAndClaims?.previousPolicyDetails
              ?.policyCoverType,
          },
          {
            label: 'Policy Start Date',
            text: buyMotorPolicy?.additionalTabDetails
              ?.previousInsuranceAndClaims?.previousPolicyDetails
              ?.policyStartDate,
          },
          {
            label: 'Policy Expiry Date',
            text: buyMotorPolicy?.additionalTabDetails
              ?.previousInsuranceAndClaims?.previousPolicyDetails
              ?.policyExpiryDate,
          },
        ],
      },
      
      // productCode?.toString() == '3152'
      // ?
      //   console.log('TP')
      // :console.log("inelse"),
     
      // productCode?.toString() == '3152'
      // ?
      // {
      //   grid_type: 'data',
      //   title: 'TP Policy Details',
      //   // borderClassName: 'border-t-2 border-neutral pt-4',
      //   // isBorderRequired: true,
      //   grid_data: [
      //     {
      //       label: 'TP Previous Insurer Name',
      //       // text: getDomainData(
      //       //   rolloverCompanyList,
      //       text: productCode?.toString() === '3152' ?
      //       buyMotorPolicy?.additionalTabDetails
      //           ?.previousInsuranceAndClaims?.previousPolicyDetails
      //           ?.TPpreviousInsurerName
      //           :'',
      //       //   'code',
      //       //   'value',
      //       // ),
      //     },
      //     {
      //       label: 'Expiring Policy Number',
      //       text: productCode?.toString() === '3152' ?
      //       buyMotorPolicy?.additionalTabDetails
      //         ?.previousInsuranceAndClaims?.previousPolicyDetails
      //         ?.TPexpiringPolicyNumber
      //         :'',
      //     },
      //     {
      //       label: 'TP Policy Start Date',
      //       text: productCode?.toString() === '3152'
      //       ? buyMotorPolicy?.quoteData?.TP_Start_Date
      //       :'',
      //     },
      //     {
      //       label: 'TP Policy Expiry Date',
      //       text: productCode?.toString() === '3152'
      //       ? buyMotorPolicy?.quoteData?.TP_End_Date
      //       :'',
      //     },
      //     // {
      //     //   label: 'TP Policy Tenure',
      //     //   text: productCode.toString() === '3152'
      //     //   ? buyMotorPolicy?.quoteData?.TP_Policy_Tenure
      //     //   :'',
      //     // },
      //   ]
      // }
      // :'',
     
      {
        grid_type: 'data',
        title: 'TP Policy Details',
        borderClassName: 'border-t-2 border-neutral pt-4',
        isBorderRequired: true,
        grid_data: [
          {
            label: 'TP Previous Insurer Name',
            text: buyMotorPolicy?.quoteData?. productCode?.toString() === '3151' ?
            getDomainData(
              rolloverCompanyList,
              buyMotorPolicy?.additionalTabDetails
                ?.previousInsuranceAndClaims?.previousPolicyDetails
                ?.TPpreviousInsurerName,
              'code',
              'value',
            ) : 'NA',
          },
          {
            label: 'Expiring Policy Number',
            text: buyMotorPolicy?.quoteData?.productCode?.toString() === '3151' ?
              buyMotorPolicy?.additionalTabDetails
              ?.previousInsuranceAndClaims?.previousPolicyDetails
              ?.TPexpiringPolicyNumber
              :'NA',
          },
          {
            label: 'TP Policy Start Date',
            text: buyMotorPolicy?.quoteData?. productCode?.toString() === '3151'
            ? buyMotorPolicy?.quoteData?.TP_Start_Date
            :'NA',
          },
          {
            label: 'TP Policy Expiry Date',
            text: productCode?.toString() === '3152'
            ? buyMotorPolicy?.quoteData?.TP_End_Date
            :'NA',
          },
          // {
          //   label: 'TP Policy Tenure',
          //   text: productCode.toString() === '3152'
          //   ? buyMotorPolicy?.quoteData?.TP_Policy_Tenure
          //   :'',
          // },
        ]
      },

      {
        grid_type: 'data',
        title: 'Previous Claims',
        borderClassName: 'border-t-2 border-neutral pt-4',
        isBorderRequired: true,
        grid_data: [
          buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenureValue?.toLowerCase() ===
          'annual'
            ? {
                label: 'Total Claim Count',
                text: buyMotorPolicy?.additionalTabDetails
                  ?.previousInsuranceAndClaims?.previousClaims
                  ?.totalClaimCountValue,
              }
            : null,
          buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenureValue?.toLowerCase() ===
            'long term' &&
          buyMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousClaims
            ?.noOfClaimsYear1
            ? {
                label: 'No of Claims in Year 1',
                text: buyMotorPolicy?.additionalTabDetails
                  ?.previousInsuranceAndClaims?.previousClaims
                  ?.noOfClaimsYear1,
              }
            : null,
          buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenureValue?.toLowerCase() ===
            'long term' &&
          buyMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousClaims
            ?.noOfClaimsYear2
            ? {
                label: 'No of Claims in Year 2',
                text: buyMotorPolicy?.additionalTabDetails
                  ?.previousInsuranceAndClaims?.previousClaims
                  ?.noOfClaimsYear2,
              }
            : null,
          buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenureValue?.toLowerCase() ===
            'long term' &&
          buyMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousClaims
            ?.noOfClaimsYear3
            ? {
                label: 'No of Claims in Year 3',
                text: buyMotorPolicy?.additionalTabDetails
                  ?.previousInsuranceAndClaims?.previousClaims
                  ?.noOfClaimsYear3,
              }
            : null,
          (buyMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousClaims
            ?.totalClaimAmount && productCode?.toString()!== '3152')   ?
          {
            label: 'Total Claim Amount',
            text: buyMotorPolicy?.additionalTabDetails
              ?.previousInsuranceAndClaims?.previousClaims
              ?.totalClaimAmount
              ? CurrencyFormater(
                  `${buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.totalClaimAmount}`,
                  true,
                  false,
                  branding,
                )
              : '',
          } : 
          null,
          {
                label: 'Previous Year NCB Slab',
                text: buyMotorPolicy?.additionalTabDetails
                  ?.previousInsuranceAndClaims?.previousClaims
                  ?.previousYearNCBSlab
                  ? `${buyMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.previousYearNCBSlab} %`
                  : '',
              },
            
          !buyMotorPolicy?.proposalNumber
            ? {
                colSpan: repeat,
                label: <div className="mt-4"></div>,
                text: (
                  <Text
                    severity="action"
                    className="hover:underline cursor-pointer"
                    onClick={(_) => {
                      goToStep(2);
                      window.scrollTo({
                        top: 0,
                        behavior: 'smooth',
                      });
                    }}
                  >
                    <FontAwesomeIcon icon={faEdit} className="mr-1" />
                    <span className="font-bold">Edit Details</span>
                  </Text>
                ),
              }
            : null,
        ].filter((d) => d),
      },
    ];
 const nomineeDetailsData = [
  {
    grid_type: 'data',
    // title: 'PA Nominee Details',
    borderClassName: 'border-t-2 border-neutral pt-4',
    isBorderRequired: true,
    grid_data:[
      {
        label: 'Nominee Name',
        text: values?.ownerDriverSelect&&
        buyMotorPolicy?.additionalTabDetails
          ?.nomineeDetails?.nomineeName
          ?buyMotorPolicy?.additionalTabDetails?.nomineeDetails?.nomineeName
          :buyMotorPolicy?.nomineeDetails?.name
          ?buyMotorPolicy?.nomineeDetails?.name
          :'NA'
      },
      {
        label: 'Nominee Date of Birth',
        text: 
         values?.ownerDriverSelect
        &&buyMotorPolicy?.additionalTabDetails
          ?.nomineeDetails?.nomineeDob
          ?buyMotorPolicy?.additionalTabDetails
          ?.nomineeDetails?.nomineeDob
          :buyMotorPolicy?.nomineeDetails?.dob
          ?buyMotorPolicy?.nomineeDetails?.dob
          :'NA'
      },
      {
        label: 'Relationship',
        text: values?.ownerDriverSelect
        &&buyMotorPolicy?.additionalTabDetails
          ?.nomineeDetails?.relationshipWithNominee
          ?buyMotorPolicy?.additionalTabDetails
          ?.nomineeDetails?.relationshipWithNominee
          :buyMotorPolicy?.nomineeDetails?.relationship
          ?buyMotorPolicy?.nomineeDetails?.relationship
          :'NA'
      },
      {
        label: 'Name of Appointee',
        text: values?.ownerDriverSelect
        &&buyMotorPolicy?.additionalTabDetails
          ?.nomineeDetails?.nameOfAppointee
          ?buyMotorPolicy?.additionalTabDetails
          ?.nomineeDetails?.nameOfAppointee
          :buyMotorPolicy?.nomineeDetails?.nameOfAppointee
          ?buyMotorPolicy?.nomineeDetails?.nameOfAppointee
          :'NA'
      },
      {
        label: 'Relationship with Appointee',
        text: values?.ownerDriverSelect
        &&buyMotorPolicy?.additionalTabDetails
          ?.nomineeDetails?.relationshipWithAppointee
          ?buyMotorPolicy?.additionalTabDetails
          ?.nomineeDetails?.relationshipWithAppointee
          :buyMotorPolicy?.nomineeDetails?.relationshipWithAppointee
          ?buyMotorPolicy?.nomineeDetails?.relationshipWithAppointee
          :'NA'
      },
    ] 
  },
    ]
    // const nomineeDetailsData = [
    //   {
    //     grid_type: 'data',
    //     grid_data: [
    //       {
    //         label: 'Nominee Name',
    //         text: buyMotorPolicy?.additionalTabDetails?.nomineeDetails
    //           ?.nomineeName,
    //       },
    //       {
    //         label: 'Nominee Date of Birth',
    //         text: buyMotorPolicy?.additionalTabDetails?.nomineeDetails
    //           ?.nomineeDob,
    //       },
    //       {
    //         label: 'Relationship',
    //         text: getDomainData(
    //           PRD_NomiRelationWithMemb,
    //           buyMotorPolicy?.additionalTabDetails?.nomineeDetails
    //             ?.relationshipWithNominee,
    //           'code',
    //           'value',
    //         ),
    //       },
    //       moment(new Date(), 'DD/MM/YYYY').diff(
    //         moment(
    //           buyMotorPolicy?.additionalTabDetails?.nomineeDetails
    //             ?.nomineeDob,
    //           'DD/MM/YYYY',
    //         ),
    //         'years',
    //       ) < MINOR_THRESHOLD_AGE
    //         ? {
    //             label: 'Name of Appointee',
    //             text: buyMotorPolicy?.additionalTabDetails
    //               ?.nomineeDetails?.nameOfAppointee,
    //           }
    //         : null,
    //       moment(new Date(), 'DD/MM/YYYY').diff(
    //         moment(
    //           buyMotorPolicy?.additionalTabDetails?.nomineeDetails
    //             ?.nomineeDob,
    //           'DD/MM/YYYY',
    //         ),
    //         'years',
    //       ) < MINOR_THRESHOLD_AGE
    //         ? {
    //             label: 'Relationship with Appointee',
    //             text: getDomainData(
    //               PRD_ApointRelationWithMinNomi,
    //               buyMotorPolicy?.additionalTabDetails?.nomineeDetails
    //                 ?.relationshipWithAppointee,
    //               'code',
    //               'value',
    //             ),
    //           }
    //         : null,
    //       !buyMotorPolicy?.proposalNumber
    //         ? {
    //             colSpan: repeat,
    //             className: 'mt-2',
    //             text: (
    //               <Text
    //                 severity="action"
    //                 className="hover:underline cursor-pointer"
    //                 onClick={(_) => {
    //                   goToStep(2);
    //                   window.scrollTo({
    //                     top: 0,
    //                     behavior: 'smooth',
    //                   });
    //                 }}
    //               >
    //                 <FontAwesomeIcon icon={faEdit} className="mr-1" />
    //                 <Text className="font-bold">Edit Details</Text>
    //               </Text>
    //             ),
    //           }
    //         : null,
    //     ].filter((d) => d),
    //   },
    // ];
    const financerDetailsData = [
      {
        grid_type: 'data',
        grid_data: [
          {
            label: 'Vehicle Owned/Financed',
            text: getDomainData(
              PRD_IsYourVehicle,
              buyMotorPolicy?.additionalTabDetails?.financeDetails
                ?.vehicleOwned,
              'code',
              'value',
            ),
          },
          getDomainData(
            PRD_IsYourVehicle,
            buyMotorPolicy?.additionalTabDetails?.financeDetails
              ?.vehicleOwned,
            'code',
            'value',
          )
            ?.toLowerCase()
            ?.search('financed') !== -1
            ? {
                label: 'Financer Name',
                text: buyMotorPolicy?.additionalTabDetails
                  ?.financeDetails?.financerDetails?.financerName,
              }
            : null,
          getDomainData(
            PRD_IsYourVehicle,
            buyMotorPolicy?.additionalTabDetails?.financeDetails
              ?.vehicleOwned,
            'code',
            'value',
          )
            ?.toLowerCase()
            ?.search('financed') !== -1
            ? {
                label: 'Financer Address',
                text: buyMotorPolicy?.additionalTabDetails
                  ?.financeDetails?.financerDetails?.financerAddress,
              }
            : null,
          getDomainData(
            PRD_IsYourVehicle,
            buyMotorPolicy?.additionalTabDetails?.financeDetails
              ?.vehicleOwned,
            'code',
            'value',
          )
            ?.toLowerCase()
            ?.search('financed') !== -1
            ? {
                label: 'Financer Agreement Type',
                text: getDomainData(
                  PRD_FinancerAgreementType,
                  buyMotorPolicy?.additionalTabDetails?.financeDetails
                    ?.financerDetails?.financerAgreementType,
                  'code',
                  'value',
                ),
              }
            : null,
          getDomainData(
            PRD_IsYourVehicle,
            buyMotorPolicy?.additionalTabDetails?.financeDetails
              ?.vehicleOwned,
            'code',
            'value',
          )
            ?.toLowerCase()
            ?.search('financed') !== -1
            ? {
                label: 'Loan Account Number',
                text: buyMotorPolicy?.additionalTabDetails
                  ?.financeDetails?.financerDetails
                  ?.loanAccountNumber,
              }
            : null,
          getDomainData(
            PRD_IsYourVehicle,
            buyMotorPolicy?.additionalTabDetails?.financeDetails
              ?.vehicleOwned,
            'code',
            'value',
          )
            ?.toLowerCase()
            ?.search('financed') !== -1
            ? {
                label: 'File Number',
                text: buyMotorPolicy?.additionalTabDetails
                  ?.financeDetails?.financerDetails?.fileNumber,
              }
            : null,
          !buyMotorPolicy?.proposalNumber
            ? {
                colSpan: repeat,
                className: 'mt-2',
                text: (
                  <Text
                    severity="action"
                    className="hover:underline cursor-pointer"
                    onClick={(_) => {
                      goToStep(2);
                      window.scrollTo({
                        top: 0,
                        behavior: 'smooth',
                      });
                    }}
                  >
                    <FontAwesomeIcon icon={faEdit} className="mr-1" />
                    <Text className="font-bold">Edit Details</Text>
                  </Text>
                ),
              }
            : null,
        ].filter((d) => d),
      },
    ];
    const uploadDocsData = [
      {
        grid_type: 'data',
        grid_data: [
          {
            label: '',
            colSpan: repeat,
            className: 'my-4',
            text: documentsPreloaded && documentsPreloaded?.length > 0
            ? documentsPreloaded?.map((document, documentIdx) => {
              return (
                  <Paper
                    key={documentIdx}
                    className={`my-4 ${
                      documentIdx === 0 ? '-mt-1' : ''
                    } bg-neutral border border-neutral-darker p-4 rounded`}
                  >
                    <Grid repeat={repeat} gap={0} gapX={0} gapY={0}>
                      <GridItem
                        colSpan={
                          screenType?.toString()?.toLowerCase() === 'mobile'
                            ? 1
                            : 2
                        }
                      >
                        <Text>
                          <Text>
                            <FontAwesomeIcon
                              icon={faPaperclip}
                              size="1x"
                              className="mr-3"
                            />
                          </Text>
                          <Text
                            severity={'info'}
                            className={'font-semibold'}
                          >
                            {document?.documentDescription &&
                            document?.documentName?.toString()?.toLowerCase() ===
                              'others'
                              ? document?.documentDescription
                              : document?.documentName}
                          </Text>
                          <Text
                            className={'flex flex-col ml-7'}
                            severity={'neutral-darker'}
                            type={'label'}
                          >
                            <Text className={'flex items-center flex-wrap'}>
                              <Text type={'label'}>File Name:&nbsp;</Text>
                              <Text
                                type={'label'}
                                className={'break-normal'}
                              >
                                {document?.documentFileNameWithExtension}
                              </Text>
                            </Text>
                          </Text>
                          <Text
                            className={'flex flex-col ml-7'}
                            severity={'neutral-darker'}
                            type={'label'}
                          >
                            File Size:&nbsp;
                            {document?.documentSize} KB
                          </Text>
                        </Text>
                      </GridItem>
                      <GridItem
                        colSpan={
                          screenType?.toString()?.toLowerCase() === 'mobile'
                            ? repeat
                            : 1
                        }
                        className={'flex flex-col justify-center items-end'}
                      >
                        <Text className="flex justify-end items-center">
                          <Button
                            size={'small'}
                            type={'button'}
                            flat={true}
                            className="w-full md:w-56 md:pr-4 max-h-10 -ml-0.5"
                            iconPre={
                              loadingDocument &&
                              documentIdx === viewDocIdx ? (
                                <FontAwesomeIcon
                                  icon={faSpinner}
                                  spin={true}
                                />
                              ) : <FontAwesomeIcon icon={faDownload} />
                            }
                            onClick={(_) => {
                              setViewDocIdx(documentIdx);
                                    viewDocument({
                                      variables: {
                                        input: {
                                          viewDocumentFor: {
                                            customerID: values
                                              ?.selectedCustomer
                                              ?.cust_number
                                              ? values
                                                  ?.selectedCustomer
                                                  ?.cust_number
                                              : '',
                                            policyID: values
                                              ?.selectedPolicy
                                              ?.policyNumber
                                              ? values?.selectedPolicy
                                                  ?.policyNumber
                                              : '',
                                              proposalNumber: dataBuyMotorPolicy?.buyMotorPolicy?.quoteData?.quotationNo
                                              ? dataBuyMotorPolicy?.buyMotorPolicy?.quoteData?.quotationNo :'',
                                          },
                                          // customerID:
                                          //   values?.selectedCustomer
                                          //     ?.cust_number,
                                          documentDetails: {
                                            documentID:
                                              document?.documentID,
                                            documentName:
                                              document?.documentName,
                                            documentFileName:
                                              document?.documentFileName,
                                            documentExtension:
                                              document?.documentExtension,
                                            documentSize:
                                              document?.documentSize,
                                            documentDescription:
                                              document?.documentDescription,
                                          },
                                        },
                                      },
                                    });
                            }}
                           // iconPre={<FontAwesomeIcon icon={faDownload} />}
                          >
                            {/* <FontAwesomeIcon icon={faDownload} /> */}
                            {loadingDocument &&
                                  documentIdx === viewDocIdx
                                    ? 'Downloading...'
                                    : 'Download'}{' '}
                          </Button>
                        </Text>
                      </GridItem>
                    </Grid>
                  </Paper>
                );
              })
              : [],
          },
        ]
      },
    ];

    const otherPropsTopSection = {
      flow: 'cols',
      repeat,
      gapX: 6,
      gapY: 0,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
      textType: 'normal',
      nullData: () => <Text severity="neutral">Not Captured</Text>,
    };
    const otherPropsForUploadDocs = {
      flow: 'cols',
      repeat,
      gapX: 4,
      gapY: 4,
      spaceY: 4,
      size: 'full',
      titleSeverity: 'info',
    };
    const otherPropsForCards = {
      flow: 'cols',
      textType: 'normal',
      repeat: repeat,
      gapX: 6,
      gapY: 0,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
      titleType: 'normal',
      useExpandablePaper: false,
      useGlobalExpandablePaper: true,
      globalTitleSeverity: 'info',
      globalTitleType: 'large',
      nullData: () => <Text severity="neutral">Not Captured</Text>,
    };

    return (
      <QuantaForm className="space-y-4">
        <MixedGridGroup
          {...{ data: reviewAndConfirmData, ...otherPropsTopSection }}
        />
        <span>
          <ProposerCustomerReadOnly
            reactiveVarData={buyMotorPolicy}
            goToStep={goToStep}
            renderExpandedCards={renderExpandedCards}
          />
        </span>
        {/* <MixedGridGroup
          {...{
            data: proposerDetailsData,
            ...otherPropsForCards,
            globalTitle: 'Proposer Details',
          }}
        /> */}
        <MixedGridGroup
          {...{
            data: vehicleDetailsData,
            ...otherPropsForCards,
            globalTitle: 'Vehicle Details',
            expanded: renderExpandedCards?.current?.find(
              (card) =>
                card?.cardName?.toString()?.toLowerCase() ===
                'vehicle details',
            )?.flag,
            isToggleEnabled: true,
            setExpandedCards: (expanded) => {
              renderExpandedCards.current = [
                ...renderExpandedCards?.current?.filter(
                  (card) =>
                    card?.cardName?.toString()?.toLowerCase() !==
                    'vehicle details',
                ),
                {
                  ...renderExpandedCards?.current?.find(
                    (card) =>
                      card?.cardName?.toString()?.toLowerCase() ===
                      'vehicle details',
                  ),
                  flag: expanded,
                },
              ];
            },
          }}
        />
        {(buyMotorPolicy?.quoteData?.businessTypeValue?.toLowerCase() ||
          buyMotorPolicy?.businessTypeValue?.toLowerCase() ===
            'roll over' || buyMotorPolicy?.businessType?.toLowerCase() ===
            'roll over') &&
          buyMotorPolicy?.quoteData?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
            'yes' && (
            <MixedGridGroup
              {...{
                data: prevInsuranceAndClaimsData,
                ...otherPropsForCards,
                globalTitle: 'Previous Insurance & Claims Details',
                expanded: renderExpandedCards?.current?.find(
                  (card) =>
                    card?.cardName?.toString()?.toLowerCase() ===
                    'previous insurance & claims details',
                )?.flag,
                isToggleEnabled: true,
                setExpandedCards: (expanded) => {
                  renderExpandedCards.current = [
                    ...renderExpandedCards?.current?.filter(
                      (card) =>
                        card?.cardName?.toString()?.toLowerCase() !==
                        'previous insurance & claims details',
                    ),
                    {
                      ...renderExpandedCards?.current?.find(
                        (card) =>
                          card?.cardName
                            ?.toString()
                            ?.toLowerCase() ===
                          'previous insurance & claims details',
                      ),
                      flag: expanded,
                    },
                  ];
                },
              }}
            />
          )}
        <MixedGridGroup
          {...{
            data: nomineeDetailsData,
            ...otherPropsForCards,
            globalTitle: 'Nominee Details',
          }}
        />
        <MixedGridGroup
          {...{
            data: financerDetailsData,
            ...otherPropsForCards,
            globalTitle: 'Finance Details',
            expanded: renderExpandedCards?.current?.find(
              (card) =>
                card?.cardName?.toString()?.toLowerCase() ===
                'finance details',
            )?.flag,
            isToggleEnabled: true,
            setExpandedCards: (expanded) => {
              renderExpandedCards.current = [
                ...renderExpandedCards?.current?.filter(
                  (card) =>
                    card?.cardName?.toString()?.toLowerCase() !==
                    'finance details',
                ),
                {
                  ...renderExpandedCards?.current?.find(
                    (card) =>
                      card?.cardName?.toString()?.toLowerCase() ===
                      'finance details',
                  ),
                  flag: expanded,
                },
              ];
            },
          }}
        />
        {/* <InputGridGroup {...{ data: uploadDocsData1, ...otherPropsForUploadDocs }} /> */}
        {(customerDocumentsPreloadedAuto &&
      customerDocumentsPreloadedAuto?.length > 0 ) &&
      (<MixedGridGroup
        {...{
          data: uploadDocsData,
          ...otherPropsForCards,
          globalTitle: 'Uploaded Document',
          expanded: renderExpandedCards?.current?.find(
            (card) =>
              card?.cardName?.toString()?.toLowerCase() ===
              'uploaded document',
          )?.flag,
          isToggleEnabled: true,
          setExpandedCards: (expanded) => {
            renderExpandedCards.current = [
              ...renderExpandedCards?.current?.filter(
                (card) =>
                  card?.cardName?.toString()?.toLowerCase() !==
                  'uploaded document',
              ),
              {
                ...renderExpandedCards?.current?.find(
                  (card) =>
                    card?.cardName?.toString()?.toLowerCase() ===
                    'uploaded document',
                ),
                flag: expanded,
              },
            ];
          },
        }}
      />) } 
      </QuantaForm>
    );
  };
  return (
    <QuantaFormik
      innerRef={props?.forwardedRef}
      enableReinitialize={true}
      {...{
        initialValues,
        validate,
        onSubmit,
        validator: () => ({}),
      }}
    >
      <ReviewAndConfirmForm {...{ validate }} />
    </QuantaFormik>
  );
}
